import React from "react";

// Default rows for oversight table
export const defaultOversightRows = [
  { aspect: "Strategy and business model", oversightForm: "" },
  { aspect: "Risk and opportunity assessment", oversightForm: "" },
  { aspect: "Policies, targets, and action plans", oversightForm: "" },
  { aspect: "Reporting and disclosures", oversightForm: "" },
];

const OversightFormTable = ({ oversightFormTable, setOversightFormTable }) => {
  const handleInputChange = (rowIndex, value) => {
    const updatedData = [...oversightFormTable];
    updatedData[rowIndex].oversightForm = value;
    setOversightFormTable(updatedData);
  };

  React.useEffect(() => {
    if (!oversightFormTable || oversightFormTable.length === 0) {
      setOversightFormTable(defaultOversightRows);
    }
  }, []);

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "0.6px solid #999",
        borderRadius: "12px",
        overflow: "hidden",
        width: "120%",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: 0,
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th
              style={{
                ...tableHeaderStyle,
                textAlign: "left",
                paddingLeft: "20px",
              }}
            >
              Aspect
            </th>
            <th style={tableHeaderStyle}>
              Oversight form <br />
              <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                (Information only / Consultation / Decision-making)
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          {oversightFormTable.map((row, index) => (
            <tr key={index}>
              <td
                style={{
                  ...tableCellStyle,
                  textAlign: "left",
                  fontWeight: "bold",
                  paddingLeft: "20px",
                  backgroundColor: "#D3C9CE",
                }}
              >
                {row.aspect}
              </td>
              <td style={tableCellStyle}>
                <input
                  type="text"
                  placeholder="Details"
                  value={row.oversightForm}
                  onChange={(e) => handleInputChange(index, e.target.value)}
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles (same as your reference)
const tableHeaderStyle = {
  padding: "25px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
};

const tableCellStyle = {
  padding: "16px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
};

const inputStyle = {
  width: "90%",
  padding: "16px",
  borderRadius: "8px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

export default OversightFormTable;
